import React, { useEffect } from 'react';
import { Filter, List, ReferenceField, TextField } from 'react-admin';

import {
  Grid,
  ListPagination,
  ManyField,
  PhoneField,
  ReferenceInput, SelectArrayInput,
  SelectInput,
  TextInput,
} from '@components';
import { UserStatusField, userStatusOptions } from '@pages/user/UserStatusField';
import { rbac } from '@utils';
import { creditStatusBlankOptions } from '@pages/credit/CreditStatusField';

interface UsersListProps {
  selectedUsersIds: number[];
  setSelectedUsersIds: (selectedIds: number[]) => void;
  className?: string;
  listClassName?: string;
}

export const UsersList = (
  { selectedUsersIds, setSelectedUsersIds, className, listClassName }: UsersListProps,
) => {
  const BulkActionButtons = ({ selectedIds }: any) => {
    useEffect(() => {
      setSelectedUsersIds(selectedIds);
    }, [selectedIds]);

    return <></>;
  };

  return (
    <div
      style={{
        overflowX: 'auto',
        width: '100%',
        marginTop: selectedUsersIds.length ? 0 : 48,
      }}
      className={className}
    >
      <List
        filters={<Filters />}
        resource="user"
        empty={false}
        pagination={<ListPagination />}
        sort={{ field: 'id', order: 'DESC' }}
        actions={<></>}
        className={listClassName}
      >
        <Grid
          defaultColumns={'code fullName status phone stateId latestCredit.statusEn'.split(' ')}
          bulkActionButtons={<BulkActionButtons />}
          rowClick="toggleSelection"
          style={{
            marginTop: selectedUsersIds.length ? 48 : 0,
          }}
        >
          <TextField source="fullName" />
          <UserStatusField source="status" />
          <PhoneField source="phone" isMasked={!rbac.canShowUserPhone()} />
          <ManyField source="dealers" reference="dealer.name" label="Buyers" sortable={false} />
          <ReferenceField source="stateId" reference="state">
            <TextField source="name" />
          </ReferenceField>
          <ReferenceField source="cityId" reference="city">
            <TextField source="name" />
          </ReferenceField>
          <TextField source="latestCredit.statusEn" label="Last Credit Status" />
        </Grid>
      </List>
    </div>
  );
};

const Filters = (props: any) => (
  <Filter {...props}>
    <TextInput source="q" label="Search" alwaysOn />
    <SelectInput source="status" choices={userStatusOptions} alwaysOn />
    <ReferenceInput
      source="stateId"
      reference="state"
      label="State"
      allowEmpty
      alwaysOn
      perPage={9999999999}
      sort={{ field: 'name', order: 'ASC' }}
    >
      <SelectInput optionText="name" />
    </ReferenceInput>
    <ReferenceInput
      source="buyerId"
      reference="dealer"
      label="Buyers"
      allowEmpty
      alwaysOn
      perPage={9999999999}
    >
      <SelectInput optionText="name" />
    </ReferenceInput>
    <TextInput source="city" label="City" alwaysOn />
    <SelectArrayInput
      key="latestCreditStatus"
      source="latestCreditStatus"
      label="Latest Credit Status"
      choices={creditStatusBlankOptions}
      className="MS-field"
      style={{ width: 350 }}
      alwaysOn
    />
  </Filter>
);
